export default {
	common: {
		ok: 'Ok',
		save: 'Speichern',
		save_and_next: 'Speichern und Weiter',
		yes: 'Ja',
		no: 'Nein',
		cancel: 'Abbrechen',
		update: 'Aktualisieren',
		create: 'Erstellen',
		back: 'Zurück',
		delete: 'Löschen',
		delete_confirm: 'Der Eintrag wird dauerhaft entfernt.',
		send: 'Senden',
		search: 'Suche...',
		all: 'Alle',
		none: 'Keine',
		unknown: 'Unbekannt',
		assigned: 'Zugeordnet',
		not_assigned: 'Nicht zugeordnet',
		please_select: 'Bitte auswählen',
		search_or_enter: 'Suchen oder eigene Bezeichnung eingeben',
		use_own_wording: '„{text}“ übernehmen',
		no_results: 'Keine Treffer',
		saved: 'Gespeichert',
		locked: 'Gesperrt',
		to_login: 'Zum Login',
		expired_session: 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
		clear_image: 'Bild löschen',
		preview: 'Vorschau',
		edit: 'Bearbeiten',
		edit_avatar: 'Avatar bearbeiten',
		options: 'Optionen',
		service_not_available: 'Es ist ein Fehler aufgetreten, bitte versuchen sie es später erneut.',
		render_failed: 'Beim Rendern dieses Teil der Seite ist ein Fehler aufgetreten.',
		page_failed: 'Beim Rendern dieser Seite ist ein Fehler augetreten',
		created: 'Erstellt',
		updated: 'Aktualisiert',
		loading: 'Laden',
		load_failed: 'Die Daten konnten nicht geladen werden.',
		retry: 'Erneut versuchen',
		next: 'Nächster',
	},
	// Short titles (tooltips) for buttons without a visible label. Keep them to a few words,
	// they only have to tell the user what the button does.
	buttons: {
		document_view: {
			back: 'Zurück',
			pdf: 'Als PDF herunterladen',
			pdf_short: 'PDF',
			open_pdf: 'PDF im Browser öffnen',
			print: 'Drucken',
		},
		branding_editor: {
			reset_all: 'Alles wieder vom Standard übernehmen',
			reset_record: 'Alles wieder vom Admin-Design übernehmen',
		},
		own_design: {
			adopt: 'Vom Admin-Design neu übernehmen',
		},
		block_editor: {
			as_html: 'Als HTML übernehmen',
		},
		text_templates: {
			reset: 'Auf geerbten Text zurücksetzen',
			reset_all: 'Jeden Text wieder vom Standard übernehmen',
			reset_record: 'Jeden Text wieder vom Admin-Design übernehmen',
		},
		letterhead_editor: {
			reset: 'Alles auf den geerbten Stand zurücksetzen',
			reset_record: 'Alles wieder vom Admin-Design übernehmen',
			field_default: 'Auf den geerbten Wert zurücksetzen',
			upload: 'Bild hochladen',
			remove: 'Entfernen',
			image_default: 'Standardbild',
			remove_image: 'Bild entfernen',
			download_pdf: 'PDF herunterladen',
			open_pdf: 'Im PDF-Viewer des Browsers öffnen',
			add_line: 'Zeile hinzufügen',
			add_column: 'Spalte hinzufügen',
			add_row: 'Zeile hinzufügen',
			add_item: 'Eintrag hinzufügen',
			up: 'Nach oben',
			down: 'Nach unten',
		},
		generic: {
			fill: 'Vorlage übernehmen',
			reset: 'Zurücksetzen',
		},
		mail_theme: {
			reset_all: 'Jedes Feld wieder vom Standard übernehmen',
			reset_record: 'Alles wieder vom Admin-Design übernehmen',
			send_test: 'Testmail senden',
			reset: 'Auf geerbten Wert zurücksetzen',
		},
		create: 'Neu anlegen',
		edit: 'Bearbeiten',
		delete: 'Löschen',
		save: 'Speichern',
		reset: 'Zurücksetzen',
		refresh: 'Aktualisieren',
		close: 'Schließen',
		details: 'Details anzeigen',
		collapse: 'Zuklappen',
		expand: 'Aufklappen',
		password_show: 'Passwort anzeigen',
		password_hide: 'Passwort verbergen',
		table: {
			filter: 'Filter anzeigen',
			refresh: 'Tabelle aktualisieren',
			export: 'Tabelle herunterladen',
			export_format: 'Dateiformat wählen',
			reset_settings: 'Tabelleneinstellungen löschen',
			save_settings: 'Tabelleneinstellungen merken',
			settings: 'Spalten einstellen',
			details: 'Zeilendetails anzeigen',
			show_cards: 'Als Liste anzeigen',
			show_table: 'Als Tabelle anzeigen',
			sort_direction: 'Sortierrichtung umkehren',
		},
		pagination: {
			first: 'Erste Seite',
			previous: 'Vorherige Seite',
			next: 'Nächste Seite',
			last: 'Letzte Seite',
		},
		file: {
			upload: 'Datei hochladen',
			remove: 'Datei entfernen',
		},
		image: {
			edit: 'Bild ändern',
			delete: 'Bild löschen',
			rotate_left: 'Nach links drehen',
			rotate_right: 'Nach rechts drehen',
			full: 'Ganzes Bild wählen',
		},
		header: {
			menu: 'Menü öffnen',
			applications: 'Anwendungen',
			sso_apps: 'Zurück zu {provider}',
			context: 'Kontext wechseln',
			language: 'Sprache wählen',
			notifications: 'Benachrichtigungen',
			close_notification: 'Benachrichtigung schließen',
			profile: 'Profil',
			search: 'Suche',
			context_mode: 'Modus wechseln',
		},
		sidebar: {
			minimize: 'Menü ein-/ausklappen',
			close: 'Menü schließen',
		},
		user: {
			create: 'Person einladen',
			edit: 'Person bearbeiten',
			delete: 'Person entfernen',
			resend_invitation: 'Einladung erneut senden',
			lock: 'Person sperren',
		},
		role: {
			create: 'Rolle anlegen',
			edit: 'Rolle bearbeiten',
			delete: 'Rolle löschen',
		},
		webhook: {
			create: 'Webhook anlegen',
			edit: 'Webhook bearbeiten',
			delete: 'Webhook löschen',
			enable: 'Webhook aktivieren',
			requests: 'Anfragen anzeigen',
			replay: 'Anfrage erneut senden',
			delete_request: 'Anfrage löschen',
		},
		token: {
			create: 'Token anlegen',
			revoke: 'Token widerrufen',
		},
		legal_page: {
			restore_all_defaults: 'Alle drei Seiten auf den Standardtext zurücksetzen',
		},
		config: {
			reload: 'Einstellungen neu laden',
			reset: 'Auf Standardwert zurücksetzen',
			save: 'Einstellung speichern',
		},
		maintenance: {
			reload: 'Daten neu laden',
			toggle_details: 'Details ein-/ausklappen',
			raw: 'Rohdaten anzeigen',
			wipe_metrics: 'Metriken zurücksetzen',
			retry_job: 'Job erneut ausführen',
			delete_job: 'Job löschen',
			delete_all_jobs: 'Alle fehlgeschlagenen Jobs löschen',
			clear_mail_log: 'Mail-Zähler und Fehlerliste löschen',
			test_mail: 'Testmail versenden',
			test_pdf: 'Beispielbrief als PDF drucken',
		},
	},
	pages: {
		admin: {
			users: {
				title: 'Personen',
				teams: 'Teams',
				events: 'Events',
				label: {
					email_not_verified: 'E-Mail nicht verifiziert',
					is_locked: 'Gesperrt',
					anonymized: 'Anonymisiert',
					two_factor: '2FA',
					two_factor_title: 'Zwei-Faktor-Authentifizierung eingerichtet',
				},
				send_password_reset: 'Link zum Zurücksetzen des Passworts senden',
				resend_invitation: 'Einladung erneut senden',
				resend_invitation_confirm:
					"Der Person '{name}' die Einladung erneut senden? Wer sich noch nie angemeldet hat, erhält einen neuen Link zum Festlegen des Passworts, andernfalls einen Link zum Zurücksetzen.",
				invitation_sent: 'Die Einladung mit einem neuen Link zum Festlegen des Passworts wurde per E-Mail versendet.',
				password_reset_sent: 'Ein Link zum Zurücksetzen des Passworts wurde per E-Mail versendet.',
				resend_failed: 'Die E-Mail konnte nicht versendet werden.',
				more_actions: 'Weitere Aktionen',
				set_password: 'Passwort setzen',
				password_set: 'Das neue Passwort wurde gesetzt.',
				reset_two_factor: 'Zwei-Faktor-Authentifizierung zurücksetzen',
				reset_two_factor_confirm:
					"Die Zwei-Faktor-Authentifizierung von '{name}' zurücksetzen? Die Person meldet sich dann nur mit dem Passwort an, bis sie sie neu einrichtet - verlangt eine Berechtigung sie, wird sie bei der nächsten Anmeldung zur Einrichtung aufgefordert.",
				two_factor_reset: 'Die Zwei-Faktor-Authentifizierung wurde zurückgesetzt.',
				lock: 'Sperren',
				unlock: 'Entsperren',
				lock_confirm: "'{name}' sperren? Die Person kann sich nicht mehr anmelden, bis sie entsperrt wird.",
				unlock_confirm: "'{name}' entsperren? Die Person kann sich wieder anmelden.",
			},
			settings: {
				legal_pages: {
					title: 'Rechtliche Seiten',
					imprint: 'Impressum',
					privacy: 'Datenschutzerklärung',
					disclosure: 'Responsible Disclosure',
					unsaved: 'Ungespeicherte Änderungen',
				},
				roles_and_permissions: {
					roles: 'Rollen',
					permissions: 'Berechtigungen',
					requires_two_factor: 'Erfordert Zwei-Faktor-Authentifizierung',
					requires_two_factor_text:
						'Wer eine so markierte Berechtigung hat, muss die Zwei-Faktor-Authentifizierung nutzen: Ohne sie wird sie bei der nächsten Anmeldung eingerichtet, und sie lässt sich nicht abschalten. Anmeldungen über Microsoft oder Authentik sind davon nicht betroffen.',
					requires_two_factor_saved: 'Gespeichert - gilt ab der nächsten Anmeldung',
				},
				map: {
					general: 'Allgemein',
					preview: 'Vorschau',
					layer: 'Pläne',
					overlays: 'Overlays',
				},
				webhook_incomings: {
					title: 'Eingehende Webhooks',
					info: 'Eingehende Webhooks nehmen HTTP-Requests anderer Dienste unter dem angegebenen API-Endpunkt entgegen. Die Requests werden protokolliert und können über eine Handler-Klasse verarbeitet werden.',
				},
				webhook_outgoings: {
					title: 'Ausgehende Webhooks',
					info: 'Ausgehende Webhooks senden bei ausgewählten Ereignissen einen HTTP-Request an die angegebene URL. Der Versand erfolgt über die Queue im Hintergrund.',
				},
			},
			webhook_incoming_requests: {
				title: 'Eingehende Webhook Requests',
			},
			webhook_outgoing_requests: {
				title: 'Ausgehende Webhook Requests',
			},
		},
		legal: {
			back_to_login: 'Zurück zum Login',
			load_failed: 'Der Text konnte nicht geladen werden. Bitte versuchen Sie es später erneut.',
		},
		me: {
			notifications: {
				title: 'Benachrichtigungen',
				email: {
					title: 'e-Mail',
					text: 'Hier kannst du e-Mail Benachrichtigungen aktivieren oder deaktivieren.',
					activate: 'e-Mail Benachrichtigungen aktivieren',
				},
				email_activate: 'e-Mail Benachrichtigungen aktivieren',
				pushover: {
					title: 'Pushover',
					text: 'Pushover als Notification Channel benutzen',
					activate: 'Pushover Notification Channel aktivieren',
					user_key: 'Pushover User Key',
				},
				telegram: {
					title: 'Telegram',
					text: 'Telegram als Notification Channel benutzen',
					activate: 'Telegram Notification Channel aktivieren',
					chat_id: 'Telegram Chat ID',
				},
			},
			security: {
				title: 'Sicherheit',
				pat: {
					title: 'Private Access Token',
					text: 'Token für Automatisierungen und Skripte, die die API der Anwendung aufrufen.',
					text_mcp:
						'Token für Automatisierungen und Skripte, die die REST-API aufrufen, oder für KI-Assistenten wie Claude oder Mistral über MCP.',
					forever: 'Unbegrenzt',
					expired: 'Abgelaufen',
					never: 'Nie',
				},
			},
		},
		profile: {
			firstname: 'Vorname',
			lastname: 'Nachname',
			email: 'E-Mail-Adresse',
			current_password: 'Aktuelles Passwort',
			new_password: 'Neues Passwort',
			password: 'Passwort',
			password_text: 'Versichere dich dass du ein langes und zufälliges Passwort benutzt um sicher zu bleiben',
			password_confirm: 'Neues Passwort bestätigen',
			profile_updated: 'Profil aktualisiert',
			password_updated: 'Passwort aktualisiert',
			avatar: 'Avatar',
			avatar_text: 'Wähle ein individuelles Profilbild.',
			profile: 'Profil',
			profile_text: 'Update die Informationen deines Profils.',
			two_factor: 'Zwei-Faktor-Authentifizierung',
			two_factor_text:
				'Zusätzlich zum Passwort wird beim Anmelden ein Code aus einer Authenticator-App abgefragt.',
		},
		auth: {
			login: {
				title: 'Loggen Sie sich in Ihr Konto ein',
				text: 'Geben Sie Benutzernamen und Passwort ein.',
				email: 'E-Mail-Adresse',
				password: 'Passwort',
				remember_me: 'Angemeldet bleiben',
				sign_in: 'Anmelden',
				loading: 'Anmeldung läuft...',
				register: {
					text: 'Sie haben noch kein Konto?',
					link: 'Mit E-Mail-Adresse registrieren',
				},
				password_reset: {
					link: 'Passwort vergessen?',
				},
				error: {
					invalid_login: 'Ungültige E-Mail-Adresse oder ungültiges Passwort.',
					too_many_requests: 'Zu viele Anmeldeversuche. Bitte versuchen Sie es später erneut.',
					service_unavailable: 'Dienst momentan nicht verfügbar. Bitte versuchen Sie es später erneut.',
					invalid_two_factor_code:
						'Der Code ist nicht korrekt. Bitte den aktuellen Code aus der App eingeben.',
					sso_identity_conflict:
						'Diese E-Mail-Adresse ist bereits mit einem anderen Konto bei diesem Anbieter verknüpft. Bitte an die Administration wenden.',
					sso_rejected:
						'Die Anmeldung konnte nicht abgeschlossen werden. Bitte an die Administration wenden.',
					sso_locked: 'Das Konto ist gesperrt. Bitte an die Administration wenden.',
					sso_wrong_tenant: 'Konten dieser Microsoft-Organisation können sich hier nicht anmelden.',
					//notVerified: 'Ihre E-Mail-Adresse wurde noch nicht verifiziert. Bitte nutze den Link in der Anmeldebestätigung.',
					//ylocked: 'Ihr Login wurde deaktiviert. Bitte melde dich bei support@crewadmin.de',
				},
				two_factor: {
					title: 'Zwei-Faktor-Authentifizierung',
					text: 'Noch ein Schritt: Bitte den Code aus Ihrer Authenticator-App eingeben.',
					submit: 'Weiter',
				},
				two_factor_setup: {
					title: 'Zwei-Faktor-Authentifizierung einrichten',
					text: 'Für Ihr Konto ist die Zwei-Faktor-Authentifizierung vorgeschrieben. Bitte den QR-Code mit einer Authenticator-App scannen und den ersten angezeigten Code eingeben.',
				},
				social: {
					divider: 'oder',
					google: 'Mit Google anmelden',
					microsoft: 'Mit Microsoft-Konto anmelden',
					apple: 'Mit Apple anmelden',
					keycloak: 'Mit Keycloak anmelden',
					authentik: 'Mit Authentik anmelden',
				},
				//resendVerification: 'Anmeldebestätigung erneut senden.',
			},
			register: {
				title: 'Erstellen Sie sich Ihr Konto',
				text: 'Geben Sie Ihre Daten ein.',
				firstname: 'Vorname',
				lastname: 'Nachname',
				email: 'E-Mail-Adresse',
				password: 'Passwort',
				confirm_password: 'Passwort bestätigen',
				accept_terms: 'Ich habe die <a href="{href}">Datenschutzerklärung</a> zur Kenntnis genommen.',
				sign_up: 'Mit E-Mail-Adresse registrieren',
				disabled: 'Registrierung ist deaktiviert',
				login: {
					text: 'Sie haben bereits ein Konto?',
					link: 'Mit E-Mail-Adresse oder SSO anmelden',
				},
				error: {
					email_exists: 'Die E-Mail-Adresse ist bereits registriert.',
				},
				mail_taken: 'Die E-Mail-Adresse wird bereits genutzt.',
				completed_text:
					'Bitte überprüfen Sie das E-Mail-Postfach. Wir haben Ihnen eine E-Mail mit den Anweisungen zum Anmelden zugesandt.',
			},
			password_reset: {
				title: 'Passwort zurücksetzen',
				text: 'Geben Sie Ihre E-Mail-Adresse ein und wir werden Ihnen Anweisungen zum Zurücksetzen Ihres Passworts zusenden.',
				email: 'E-Mail-Adresse:',
				send_reset_link: 'Weiter',
				completed_text:
					'Bitte überprüfen Sie das E-Mail-Postfach. Wir haben Ihnen eine E-Mail mit Anweisungen zum Zurücksetzen Ihres Passworts zugesandt.',
			},
			new_password: {
				title: 'Passwort zurücksetzen',
				text: 'Geben Sie ein neues Passwort ein.',
				email: 'E-Mail-Adresse:',
				new_password: 'Neues Passwort:',
				confirm_password: 'Neues Passwort bestätigen:',
				set_new_password: 'Weiter',
			},
			set_password: {
				title: 'Passwort festlegen',
				text: 'Willkommen! Lege ein Passwort für dein Konto fest.',
				email: 'E-Mail-Adresse',
				password: 'Passwort',
				confirm_password: 'Passwort bestätigen',
				submit: 'Passwort festlegen',
				done: 'Dein Passwort ist festgelegt. Du kannst dich jetzt mit deiner E-Mail-Adresse anmelden.',
				to_login: 'Zur Anmeldung',
				invalid: 'Der Link ist abgelaufen oder wurde schon benutzt. Fordere einen neuen an, er kommt per E-Mail.',
				request_new: 'Neuen Link anfordern',
			},
		},
		settings: {
			general: {
				title: 'Allgemein',
			},
			users: {
				title: 'Personen',
			},
		},
		context: {
			settings: {
				title: 'Einstellungen: {context} {name}',
				locked: '{context} ist gesperrt: Änderungen sind gerade nicht möglich.',
			},
		},
	},
	// Meldungen der Regeln aus utils/validations.ts. Der Schlüssel ist der Name, unter dem die
	// Regel im `validations`-Prop des Feldes steht.
	validations: {
		required: 'Eingabe benötigt',
		too_long: 'Eingabe zu lang',
		too_short: 'Eingabe zu kurz',
		too_small: 'Wert zu klein',
		too_large: 'Wert zu groß',
		too_many_lines: 'Zu viele Zeilen',
		line_too_long: 'Zeile zu lang',
		invalid_email: 'E-Mail-Adresse ungültig',
		invalid_phone: 'Telefonnummer ungültig',
		invalid_url: 'Adresse ungültig, mit https:// beginnen',
		invalid_zip: 'Postleitzahl ungültig',
		invalid_country: 'Länderkürzel aus zwei Buchstaben',
		mismatch: 'Eingaben stimmen nicht überein',
		template_invalid: 'Platzhalter ungültig',
		not_member: 'Nicht mehr unter den Auswahlmöglichkeiten',
		not_event_member: 'Nicht mehr alle unter den Auswahlmöglichkeiten',
	},
	sidebar: {
		home: 'Übersicht',
		blank: 'Leer',
		cards: 'Cards',
		graph: 'Graph',
		table: 'Tabelle',
		users: 'Personen',
		settings: 'Einstellungen',
		development: 'Entwicklung',
		swagger: 'Swagger UI',
		support: 'Support',
		maintenance: 'Wartung',
	},
	components: {
		pwa_notify: {
			update: 'Eine neue Version ist da',
			update_now: 'Aktualisieren',
			offline_ready: 'Die App ist jetzt auch ohne Verbindung nutzbar',
			offline: 'Keine Verbindung',
			offline_text: 'Angezeigt wird der letzte Stand.',
			online: 'Wieder verbunden',
		},
		save_footer: {
			save: 'Speichern',
			reset_all: 'Alles auf Standard zurücksetzen',
			discard: 'Zurücksetzen',
			unsaved: 'Ungespeicherte Änderungen',
			saved: 'Alles gespeichert',
			shortcut: 'Speichern ({key})',
			confirm_title: 'Alles auf Standard zurücksetzen?',
			confirm_text: 'Alle Felder gehen auf ihren Ausgangswert zurück. Gespeichert wird erst mit Speichern.',
		},
		template_editor: {
			groups: {
				data: 'Daten',
				document: 'Dokument',
				general: 'Allgemein',
				self: 'Dieser Block',
				mail: 'Mail',
				regions: 'Bereiche',
			},
			// What a placeholder is, by its name and, failing that, by its last part; the editors fall back to these.
			placeholders: {
				general: {
					sender_name: 'Absender',
					ink_color: 'Überschriftenfarbe',
					text_color: 'Textfarbe',
					muted_color: 'Gedämpfte Farbe',
					accent_color: 'Akzentfarbe',
					font_family: 'Schriftart',
					font_size: 'Schriftgröße',
					line_height: 'Zeilenabstand',
					rule: 'Linie, als CSS-Hintergrund',
					rule_height: 'Linienhöhe',
					rule_color: 'Linie, als eine Farbe',
					rule_px: 'Linienhöhe in Pixeln',
					image_1_url: 'Bild 1, als Bildquelle',
					image_2_url: 'Bild 2, als Bildquelle',
					claim: 'Claim',
					addition_text: 'Zusatztext',
					has_contact_lines: 'Gibt es Kontaktzeilen',
					contact_lines: 'Kontaktzeilen',
					has_footer_columns: 'Gibt es Fußspalten',
					footer_columns: 'Spalten der Fußzeile',
					footer_rows: 'Zeilen der Fußzeile',
				},
				mail: {
					app_url: 'Adresse der App',
					year: 'Das aktuelle Jahr',
					link_color: 'Linkfarbe',
					primary_color: 'Buttonfarbe',
					success_color: 'Erfolgsfarbe',
					error_color: 'Fehlerfarbe',
				},
				data: {
					document_title: 'Was das Dokument ist, z.B. Rechnung',
					document_number: 'Die Nummer des Dokuments',
					document_date: 'Das Datum des Dokuments',
					signature: 'Der Name, mit dem das Schreiben unterzeichnet ist',
				},
				self: {
					addition: 'Zusatz',
					addition_url: 'Zusatz, als Bildquelle',
					addition_is_text: 'Zusatz ist Text',
					addition_align: 'Ausrichtung zum Logo',
					addition_height: 'Höhe Zusatz',
					addition_place: 'Lage Zusatz',
					align: 'Ausrichtung',
					bleed: 'Bis an den Rand',
					card_background: 'Inhaltshintergrund',
					card_border_color: 'Rahmenfarbe',
					page_background: 'Seitenhintergrund',
					claim: 'Claim zeigen',
					claim_align: 'Lage Claim',
					claim_by_addition: 'Claim unter dem Zusatz',
					color: 'Farbe',
					columns: 'Spalten',
					contact: 'Kontaktblock zeigen',
					contact_bar: 'Balken am Kontaktblock',
					contact_icons: 'Icons im Kontaktblock',
					content_width: 'Inhaltsbreite',
					copyright: 'Copyright-Zeile',
					duplex: 'Doppelseitig',
					punch_mark: 'Lochmarke',
					fold_marks: 'Faltmarken',
					folds: 'Lage der Faltmarken',
					fold_top: 'Erste Faltmarke ab oben',
					fold_height: 'Abstand der Faltmarken',
					top: 'Anschriftfeld ab oben',
					return_line: 'Rücksendeangabe',
					margin_left: 'Rand links',
					margin_right: 'Rand rechts',
					header_first_top: 'Kopf Seite 1 von oben',
					header_follow_top: 'Kopf Folgeseiten von oben',
					text_first_top: 'Text Seite 1 ab oben',
					text_follow_top: 'Text Folgeseiten ab oben',
					footer_first_bottom: 'Fuß Seite 1 von unten',
					footer_first_height: 'Fußhöhe Seite 1',
					footer_follow_bottom: 'Fuß Folgeseiten von unten',
					footer_follow_height: 'Fußhöhe Folgeseiten',
					page_bottom_first: 'Unterer Seitenrand Seite 1',
					page_bottom_follow: 'Unterer Seitenrand Folgeseiten',
					number_bottom_first: 'Seitenzahl Seite 1 von unten',
					number_bottom_follow: 'Seitenzahl Folgeseiten von unten',
					height: 'Höhe',
					width: 'Breite',
					image: 'Grafik',
					image_url: 'Grafik, als Bildquelle',
					layout: 'Anordnung',
					logo: 'Logo',
					logo_url: 'Logo, als Bildquelle',
					logo_is_text: 'Logo ist Text',
					logo_height: 'Logohöhe',
					logo_offset: 'Logoversatz',
					logo_width: 'Logo-Breite',
					rows: 'Zeilen',
					rule: 'Linie zeigen',
				},
				content: 'Der Inhalt der Mail',
				header: 'Der Kopfbereich',
				footer: 'Der Fußbereich',
				header_bleed: 'Kopf reicht bis an den Rand',
				footer_bleed: 'Fuß reicht bis an den Rand',
				icon: 'Icon',
				text: 'Text',
				title: 'Überschrift',
				lines: 'Zeilen',
				items: 'Einträge',
				label: 'Bezeichnung',
				value: 'Wert',
			},
			variables: 'Platzhalter',
			insert: 'An der Cursorposition einfügen, um eine Markierung herum',
			field_hint: 'Nur innerhalb von {section} verfügbar',
			search: 'Platzhalter suchen',
			none_found: 'Kein Platzhalter passt.',
			kinds: {
				text: 'Texte',
				html: 'HTML',
				list: 'Listen',
				flag: 'Bedingungen',
			},
			languages: {
				text: 'Text',
				html: 'HTML',
				css: 'CSS',
				json: 'JSON',
			},
			issues: {
				syntax: 'Ein Abschnitt ist nicht geschlossen oder falsch verschachtelt',
				unknown: 'Unbekannter Platzhalter: {name}',
				not_printable: '{name} ist eine Liste oder ein Schalter und nur als Abschnitt nutzbar',
				unsupported: 'Dieser Tag wird nicht unterstützt: {name}',
			},
		},
		letterhead_editor: {
			settings: 'Einstellungen des Briefpapiers',
			preview: 'Vorschau des Briefpapiers',
			title: 'Briefpapier',
			saved: 'Briefpapier gespeichert',
			overrides_disabled: 'Eigene Briefpapiere sind in dieser App ausgeschaltet.',
			no_image: 'Kein Bild',
			popup_blocked: 'Der Browser hat das neue Fenster blockiert. Bitte Pop-ups für diese Seite erlauben.',
			duplex: {
				title: 'Doppelseitig',
				text: 'Für den beidseitigen Druck: Der erste Rand liegt innen an der Bindung, der zweite außen. Die geraden Seiten werden gespiegelt, mit Kopf, Fuß und Seitenzahl. Die Lochmarke steht dann nur auf den Vorderseiten.',
			},
			fold_marks: {
				title: 'Faltmarken',
				text: 'Zwei kurze Linien im linken Rand von Seite 1 nach DIN 5008, wo der Brief für ein Fensterkuvert gefaltet wird. Wo sie sitzen, gibt die Form des Anschriftfelds vor: Form A bei 87 und 192 mm, Form B bei 105 und 210 mm. Ohne Anschriftfeld gibt es keine.',
			},
			address_top: {
				title: 'Anschriftfeld ab oben',
				text: 'Wo das Anschriftfeld beginnt, in Millimetern vom oberen Papierrand; die Form gibt den Wert nach DIN 5008 vor. Der Brieftext von Seite 1 beginnt darunter.',
			},
			text_first_top: {
				title: 'Text ab oben',
				text: 'Wo der Brieftext auf Seite 1 beginnt, solange es kein Anschriftfeld gibt. Mit Anschriftfeld gibt das Anschriftfeld die Stelle vor.',
			},
			punch_mark: {
				title: 'Lochmarke',
				text: 'Eine kurze Linie im linken Rand auf halber Höhe (148,5 mm) nach DIN 5008. Sie zeigt, wo der Locher ansetzt, auf jeder Seite des Briefs.',
			},
			text_top: {
				title: 'Text ab oben',
				text: 'Wo der Brieftext auf dieser Seite beginnt, in Millimetern vom oberen Papierrand. Er sollte unter dem Kopf liegen.',
			},
			footer_height: {
				title: 'Fußhöhe',
				text: 'Wie hoch die Fußzeile ist. Der Brieftext endet so weit über "Fuß von unten".',
			},
			contact_lines_hint: 'Ein Font-Awesome-Name pro Zeile, z.B. phone. Mehrzeilige Texte und Platzhalter mit mehreren Zeilen werden zu mehreren Zeilen.',
			empty_row: 'Leere Zeile',
			samples: {
				label: 'Beispiel',
				one_page: 'Brief, 1 Seite',
				two_pages: 'Entwurf, 2 Seiten',
				table: 'Tabelle über 2 Seiten',
			},
			blocks: {
				skeleton: 'Grundgerüst',
				header_first: 'Briefkopf Seite 1',
				header_follow: 'Briefkopf Folgeseiten',
				address: 'Anschriftfeld',
				footer_first: 'Fußzeile Seite 1',
				footer_follow: 'Fußzeile Folgeseiten',
			},
			css_hints: {
				skeleton: 'Das CSS der Seite: Ränder und wo Kopf, Text und Fuß stehen. Die Werte im JSON darüber heißen hier self.margin_left usw. Das Anschriftfeld bleibt das des Anschriftfelds.',
				address: 'Das CSS des Anschriftfelds und seiner Faltmarken; die Werte im JSON darüber heißen hier self.top usw.',
			},
			return_line_hint: 'Die kleine Zeile über der Anschrift, die im Fensterumschlag zu sehen ist. Ein Muster mit Platzhaltern, z.B. für die Anschrift des Standorts: Jedes Schreiben übernimmt es beim Entwerfen und kann es danach noch ändern. Leer bringt jedes Schreiben seine eigene Zeile mit.',
			content_sections: {
				header: 'Briefkopf',
				footer: 'Fußzeile',
			},
			layouts: {
				'logo-left': 'Logo links',
				'logo-right': 'Logo rechts',
				centered: 'Zentriert',
			},
			addition_places: {
				logo: 'Beim Logo',
				center: 'Mittig',
				info: 'Bei den Infos',
			},
			addition_aligns: {
				top: 'Oben',
				middle: 'Mittig',
				bottom: 'Unten',
			},
			addition_hint: {
				title: 'Zusatz',
				text: 'Beim Logo: Der Zusatz steht direkt neben dem Logo. Mittig: mittig zwischen dem Logo und dem Kontaktblock. Bei den Infos: bündig vor dem Kontaktblock. Die Ausrichtung sagt, ob er oben, mittig oder unten mit dem Logo abschließt.',
			},
			lockup: {
				image_1: 'Bild 1',
				image_2: 'Bild 2',
				text: 'Text',
				none: 'Nichts',
			},
			aligns: {
				left: 'Links',
				center: 'Mittig',
				right: 'Rechts',
			},
			logo_offset: {
				title: 'Versatz',
				text: 'Ein negativer Wert schiebt Logo und Zusatz gemeinsam in den linken Seitenrand.',
			},
			rule_background: {
				title: 'Linie',
				text: 'Ein CSS-Hintergrund: eine Farbe, ein Verlauf wie linear-gradient(90deg, #9ead41, #e35d26) oder none.',
			},
			placeholder_hints: {
				document_title: 'Was das Dokument ist, z.B. Rechnung',
				document_number: 'Die Nummer des Dokuments',
				document_date: 'Das Datum des Dokuments',
				image_1_url: 'Bild 1, als Bildquelle',
				image_2_url: 'Bild 2, als Bildquelle',
				ink_color: 'Die Farbe der Überschriften',
				text_color: 'Die Textfarbe',
				muted_color: 'Die gedämpfte Farbe',
				accent_color: 'Die Akzentfarbe',
				signature: 'Der Name, mit dem das Schreiben unterzeichnet ist',
			},
			sample: {
				return_line: 'Musterfirma · Musterstraße 1 · 12345 Musterstadt',
				watermark: 'Entwurf',
				recipient: 'Kanzlei Beispiel\nHerrn Max Mustermann\nBeispielweg 7\n54321 Beispielstadt',
				subject_label: 'Betreff:',
				subject: 'Ein Beispielbrief',
				salutation: 'Sehr geehrter Herr Mustermann,',
				body: 'dies ist ein Beispieltext. Er zeigt, wie ein Brief auf diesem Briefpapier aussieht: wo der Text beginnt, wie er umbricht und wo Kopf und Fuß sitzen.\n\nDer zweite Absatz zeigt den Abstand zwischen Absätzen.',
				closing: 'Mit freundlichen Grüßen',
				signature: 'Erika Musterfrau',
				table_position: 'Pos.',
				table_item: 'Leistung',
				table_amount: 'Betrag',
				table_row: 'Beispielposition {n}',
				table_total: 'Summe',
				table_intro: 'anbei die Aufstellung der Positionen. Die Tabelle läuft über die Seite hinaus; auf der zweiten Seite steht ihr Kopf noch einmal.',
				paragraphs: [
					'Im zweiten Teil des Beispiels geht der Brief auf die nächste Seite. Dort trägt er den Briefkopf der Folgeseiten, und unten steht die Seitenzahl. So lässt sich prüfen, ob der Text oben wie unten genug Abstand zu Kopf und Fuß hält.',
					'Ein Absatz wird nie mitten in einer Zeile getrennt, wohl aber zwischen zwei Zeilen. Wo genau die Seite endet, hängt von den Seitenmaßen ab, die im Grundgerüst eingestellt sind, und von Schriftgröße und Zeilenabstand.',
					'Längere Schreiben, etwa eine ausführliche Darstellung der Erbfolge oder eine Aufstellung von Unterlagen, laufen so über mehrere Seiten. Jede Seite nach der ersten beginnt an der Stelle, die für die Folgeseiten festgelegt ist.',
				],
			},
			closing: 'Grußformel',
			closing_hint: 'Steht unter dem Text jedes Schreibens, Zeilen und Leerzeilen wie geschrieben: Die Leerzeilen lassen Platz für die Unterschrift, der Platzhalter für den Unterzeichner setzt den Namen darunter. Leer bringt jedes Schreiben seine eigene Grußformel mit.',
		},
		letterhead_sheet: {
			loading: 'Brief wird erstellt ...',
			title: 'Brief',
			page_of: 'Seite {page} von {total}',
			pages: '{n} Seite | {n} Seiten',
		},
		// Toolbar of the GanttChart timeline component
		gantt: {
			day: 'Tag',
			week: 'Woche',
			month: 'Monat',
			today: 'Heute',
			label_header: 'Aufgabe',
			empty: 'Keine Einträge',
			collapse_labels: 'Spalte einklappen',
			expand_all: 'Alles ausklappen',
			collapse_all: 'Alles einklappen',
			expand_labels: 'Spalte ausklappen',
			allowed_range: 'Verschiebbar von {from} bis {to}',
			depends_after: 'Startet nach {label}',
			depends_together: 'Startet zusammen mit {label}',
		},
		schedule_period_bar: {
			from: 'Von',
			to: 'Bis',
			current_quarter: 'Dieses Quartal',
			current_month: 'Dieser Monat',
			current_year: 'Dieses Jahr',
			previous_period: 'Vorheriger Zeitraum',
			next_period: 'Nächster Zeitraum',
		},
		// efDropArea
		drop_area: {
			hint: 'Dateien hierher ziehen',
			browse: 'oder klicken, um sie auszuwählen',
			uploading: 'Wird hochgeladen...',
			too_large: 'Zu groß - höchstens {size}',
			retry: 'Eine Datei erneut senden | {n} Dateien erneut senden',
			clear: 'Liste leeren',
		},
		// efSourceEditor, the frame of efMarkdownEditor and efHtmlEditor
		source_editor: {
			write: 'Bearbeiten',
			preview: 'Vorschau',
			split: 'Bearbeiten & Vorschau',
			empty: 'Noch nichts für die Vorschau.',
		},
		// efHtmlEditor
		html_editor: {
			hint: 'Geschrieben in HTML, Style-Elemente eingeschlossen. Die Vorschau zeigt die Seite, wie sie aussehen wird.',
			placeholder_text: 'Text',
			placeholder_link: 'Linktext',
			toolbar: {
				bold: 'Fett',
				italic: 'Kursiv',
				heading: 'Überschrift',
				paragraph: 'Absatz',
				bullet_list: 'Aufzählung',
				numbered_list: 'Nummerierte Liste',
				link: 'Link',
			},
		},
		// efMarkdownEditor
		markdown_editor: {
			hint: 'Formatiert mit Markdown. Die Werkzeugleiste setzt die Zeichen automatisch.',
			placeholder_text: 'Text',
			placeholder_link: 'Linktext',
			placeholder_column: 'Spalte',
			toolbar: {
				bold: 'Fett',
				italic: 'Kursiv',
				strikethrough: 'Durchgestrichen',
				heading: 'Überschrift',
				bullet_list: 'Aufzählung',
				numbered_list: 'Nummerierte Liste',
				quote: 'Zitat',
				link: 'Link',
				table: 'Tabelle',
			},
		},
		color_input: {
			unset: 'Nicht gesetzt - der geerbte Wert wird verwendet',
			presets: 'Vorgeschlagene Farben',
		},
		two_factor: {
			enabled: 'Aktiv',
			disabled: 'Nicht aktiv',
			enabled_text: 'Beim Anmelden wird nach dem Passwort ein Code aus deiner Authenticator-App abgefragt.',
			disabled_text:
				'Ohne zweiten Faktor genügt dein Passwort zum Anmelden. Zum Aktivieren brauchst du eine Authenticator-App auf dem Handy.',
			since: 'Aktiv seit {date}',
			activate: 'Zwei-Faktor-Authentifizierung aktivieren',
			deactivate: 'Zwei-Faktor-Authentifizierung deaktivieren',
			activated: 'Zwei-Faktor-Authentifizierung aktiviert',
			deactivated: 'Zwei-Faktor-Authentifizierung deaktiviert',
			required: 'Vorgeschrieben',
			required_text:
				'Deine Berechtigungen erfordern die Zwei-Faktor-Authentifizierung, deshalb lässt sie sich nicht abschalten.',
			required_missing_text:
				'Deine Berechtigungen erfordern die Zwei-Faktor-Authentifizierung. Bitte aktiviere sie jetzt - sonst wirst du bei der nächsten Anmeldung dazu aufgefordert.',
			code: 'Verifizierungscode',
			secret: 'Oder diesen Schlüssel manuell eintragen',
			copy: 'In die Zwischenablage kopieren',
			copied: 'Schlüssel kopiert',
		},
		mail_theme: {
			settings: 'Einstellungen des Mail-Designs',
			title: 'Mail-Design',
			popover: {
				title: 'Mail-Design',
				text: 'Farben, Logo und die HTML-Bausteine, aus denen jede E-Mail aufgebaut wird.',
			},
			overrides_disabled: 'Eigene Designs sind für diese App nicht aktiviert.',
			regions: {
				content: 'Der Inhalt der Mail',
				header: 'Der Kopfbereich',
				footer: 'Der Fußbereich',
			},
			samples: {
				label: 'Beispielmail',
				action: 'Mit Button',
				list: 'Mit Auflistung',
			},
			viewports: {
				label: 'Breite der Vorschau',
				desktop: 'Desktop',
				mobile: 'Smartphone',
			},
			preview_title: 'Vorschau',
			saved: 'Mail-Design gespeichert',
			groups: {
				links: 'Farben',
				images: 'Bilder',
			},
			blocks: {
				skeleton: 'Grundgerüst',
				header: 'Kopfzeile',
				footer: 'Fußzeile',
			},
			skeleton_hint: 'Der Rahmen der Mail um den Inhalt. content, header und footer setzen die Nachricht, Kopfzeile und Fußzeile ein; die Werte im JSON darüber heißen self.page_background usw.',
			copyright_hint: 'Die Zeile unter der Mail, mit Platzhaltern wie dem Jahr oder dem Absender. Leer fällt sie weg.',
			embed_images: {
				title: 'Bilder einbetten',
				text: 'Logo, Bilder und Grafiken des Designs kommen als Teil der Mail mit (CID), statt beim Öffnen nachgeladen zu werden. So zeigen auch das klassische Outlook und Gmail sie ohne Nachfrage; die Mail wird um die Bilder größer, manche Programme listen sie zusätzlich als Anhang. Die Vorschau hier zeigt sie weiter verlinkt, die Testmail eingebettet.',
			},
			block_color: {
				title: 'Farbe',
				text: 'Leer gilt die Farbe aus dem Tab Allgemein.',
			},
			closing: 'Grußformel',
			closing_hint: 'Steht unter jeder Mail, die keine eigene mitbringt, Zeilen wie geschrieben, mit Platzhaltern wie dem Absender. Leer fällt sie weg.',
		},
		document_view: {
			pdf_failed: 'Das PDF konnte nicht erstellt werden.',
		},
		text_templates: {
			title: 'Textvorlagen',
			hint_app: 'Die Texte, aus denen die Dokumente und Mails geschrieben werden. Leere Felder verwenden den Standard der App.',
			overrides_disabled: 'Eigene Texte sind für diese App nicht aktiviert.',
			preview: 'Mit Beispielwerten',
			saved: 'Textvorlagen gespeichert',
		},
		branding_editor: {
			title: 'Absender & Gestaltung',
			settings: 'Gemeinsame Einstellungen von E-Mail und Briefpapier',
			preview: 'Vorschau',
			header_hint: 'Was davon ein Kopf zeigt, stellt sein Design unter Mail oder Briefpapier ein; eine E-Mail zeigt den Claim.',
			sender: 'Absender',
			sender_name_hint: {
				title: 'Absender',
				text: 'Der Titel einer Mail, der Alternativtext ihres Logos und der Name unter dem Gruß. Leer gilt der Name der App.',
			},
			type: 'Schrift und Farben',
			type_hint_mail: 'Die Größe in pt, die Mail zeichnet sie in px (10,5 pt sind 14 px). Eine Mail lädt keine Schriftdateien und nimmt die erste Schrift der Liste, die das Mailprogramm kennt.',
			type_hint: 'Für Brief und Mail. Die Größe in pt gilt für den Brief, die Mail zeichnet sie in px (10,5 pt sind 14 px); eine Mail lädt keine Schriftdateien und nimmt die nächste Schrift der Liste. Mit jedem Brief gehen diese Schriften mit:',
			accents: 'Akzente',
			contact: 'Kontaktblock',
			footer: 'Fußzeile',
			css: 'Eigenes CSS',
			css_hint_mail: 'Gilt für die Mail, die übernimmt, was passt. general.feldname setzt die Werte von oben ein. Klassen:',
			css_hint: 'Gilt für Brief und Mail; im Brief nur auf dem Blatt. general.feldname setzt die Werte von oben ein. Klassen:',
			rule: 'Linie',
			rule_hint_mail: 'Die Linie unter dem Kopf und über dem Fuß der E-Mail. Die E-Mail zeichnet die Stärke in Pixeln, 1,3 mm sind 5 px.',
			rule_hint: 'Die Linie unter dem Kopf und über dem Fuß, im Brief wie in der E-Mail. Die E-Mail zeichnet die Stärke in Pixeln, 1,3 mm sind 5 px.',
			overrides_disabled: 'Ein eigenes Design ist für diese App nicht aktiviert.',
			saved: 'Design gespeichert',
			media: {
				label: 'Vorschau als',
				letter: 'Brief',
				mail: 'E-Mail',
			},
		},
		design_editor: {
			parts: {
				branding: 'Allgemein',
				mail: 'Mail',
				letterhead: 'Briefpapier',
			},
		},
		own_design: {
			label: 'Eigenes Design',
			on: 'Nutzt ein eigenes Design. Änderungen am Admin-Design kommen hier nicht mehr an.',
			off: 'Nutzt das Design der Administration. Eingeschaltet startet das eigene Design als Kopie davon.',
			adopt_title: 'Admin-Design neu übernehmen?',
			adopt_text: 'Alles, was hier eingestellt ist, wird durch das aktuelle Design der Administration ersetzt. Gespeichert ist es sofort.',
		},
		block_editor: {
			designs: {
				din5008: 'DIN 5008',
				card: 'Karte',
				sheet: 'Briefbogen',
				lockup: 'Logo mit Kontaktblock',
				din5008_a: 'DIN 5008 Form A, kleiner Kopf',
				din5008_b: 'DIN 5008 Form B, großer Kopf',
				columns: 'Spalten und Zeilen',
				logo: 'Logo und Claim',
				html: 'Eigenes HTML',
				none: 'Keins',
				image: 'Bild',
				same: 'Wie Seite 1',
			},
			as_html_hint: 'Kopiert das gewählte Design als HTML in diesen Block, als Ausgangspunkt eigener Gestaltung. Seine Einstellungen kommen als JSON mit.',
			same_hint: 'Die Folgeseiten zeigen denselben Block wie Seite 1.',
			bleed: {
				title: 'Bis an den Rand',
				text: 'Im Brief reicht das Bild bis an die Papierkante, ein Kopf auch bis an den oberen, ein Fuß bis an den unteren Rand. In der Mail entfällt beim Briefbogen der Innenabstand der Karte, so schließt die Grafik die Karte ein.',
			},
			json_hint: 'Die Werte des Blocks. Im HTML darunter heißen sie self.feldname, das Allgemeine general.feldname.',
			json_invalid: 'Kein gültiges JSON-Objekt; die letzten gültigen Werte gelten weiter.',
		},
		sender: {
			images_hint: 'PNG, JPG, WebP, GIF oder SVG bis 2 MB. Ein SVG bekommt beim Hochladen eine PNG-Fassung für die E-Mails, denn Gmail und Outlook zeigen dort kein SVG; Outlook für Windows zeigt auch kein WebP.',
			upload_failed: 'Das Bild konnte nicht hochgeladen werden.',
		},
		select_user: {
			placeholder: 'Person auswählen...',
		},
		file_upload: {
			too_large: 'Datei ist zu groß — höchstens {size}',
			drop_here: 'Datei hier ablegen | Dateien hier ablegen',
		},
		// Bedienung von efTimeChart: der Zeitraum, auf den der Plot skaliert, der Weg durch die
		// Jahre daneben und die Beschriftungen im Plot selbst
		time_chart: {
			range: 'Zeitraum',
			range_years: '{years} Jahre',
			range_years_hint: 'Die nächsten {years} Jahre, mit dem Rückblick davor',
			range_full: 'Gesamt',
			range_full_hint: 'Die gesamte Laufzeit',
			previous: 'Zeitraum zurück',
			next: 'Zeitraum vor',
			reset: 'Zurück zu heute',
			today: 'heute',
			series: 'Datenreihen',
			markers: 'Markierungen',
		},
		ef_row_count: {
			page: 'Seite {current} von {total}',
			rows: 'Einträge {from} bis {to} von {total}',
			filtered: '(gefiltert von {total})',
			none: 'Keine Einträge',
		},
		ef_table: {
			elements_per_page: 'Einträge pro Seite',
			no_elements: 'Keine Einträge',
			sort_by: 'Sortieren nach',
			sort_default: 'Standardreihenfolge',
		},
		ef_import_wizard: {
			title: 'Import',
			run: 'Import starten',
			preview_failed: 'Die Vorschau konnte nicht erstellt werden.',
			apply_failed: 'Der Import konnte nicht abgeschlossen werden.',
			step: {
				file: 'Datei',
				mapping: 'Zuordnung',
				preview: 'Vorschau',
			},
			file: {
				hint: 'Excel- oder CSV-Datei mit einem Datensatz pro Zeile. Die erste Zeile muss die Spaltenüberschriften enthalten.',
				sheet: 'Tabellenblatt',
				parsed: '{rows} Zeilen mit {columns} Spalten gelesen.',
				too_many_rows: 'Die Datei enthält mehr als {max} Zeilen. Bitte in mehrere Dateien aufteilen.',
				error: 'Die Datei konnte nicht gelesen werden.',
			},
			mapping: {
				hint: 'Die Zuordnung wurde aus den Überschriften geraten. Bitte prüfen und ggf. korrigieren.',
				none: '– nicht zuordnen –',
				column: 'Spalte {index}',
			},
			report: {
				preview: 'Vorschau – es wurde noch nichts gespeichert.',
				applied: 'Import abgeschlossen',
				line: 'Zeile',
				result: 'Ergebnis',
			},
			action: {
				create: 'neu',
				update: 'aktualisiert',
				attach: 'verknüpft',
				detach: 'getrennt',
				delete: 'gelöscht',
				skipped: 'übersprungen',
				unchanged: 'unverändert',
			},
			summary: {
				rows: 'Zeilen',
				skipped: 'Übersprungen',
				warnings: 'Warnungen',
			},
			error: {
				missing_external_id: 'Keine eindeutige ID',
				duplicate_external_id: 'ID doppelt',
				missing_name: 'Kein Name',
			},
		},
		header_notification: {
			new_notifications: 'Keine Benachrichtigungen | Eine Benachrichtigung | {count} Benachrichtigungen',
			view_all: 'Alle anzeigen',
		},
		header_profile: {
			profile: 'Profil',
			settings: 'Einstellung',
			dark_mode: 'Dunkel',
			light_mode: 'Hell',
			auto_mode: 'Auto',
			theme: 'Design',
			notifications: 'Benachrichtigung',
			reverb_ping: 'Echtzeitverbindung prüfen',
			sign_out: 'Abmelden',
		},
		header_profile_i18n: {
			locale: {
				en: 'Englisch',
				de: 'Deutsch',
			},
		},
		header_search: {
			placeholder: 'Suche...',
		},
		sidebar: {
			support: {
				subject: '[{app_title}] Supportanfrage',
				body: `Hallo {app_title}-Team,

auf der Seite '{uri}' benötige ich Unterstützung.

Kurzbeschreibung:
...

Priorität/Betroffene:
- Priorität: (Blocker/Hoch/Mittel/Niedrig)
- Betroffene: (z.B. nur ich / Team / alle Nutzer)

Erwartetes Verhalten:
...

Tatsächliches Verhalten:
...

Schritte zur Reproduktion:
1) ...
2) ...
3) ...

Umgebung:
- Browser: ...
- Betriebssystem: ...

Zeitpunkt:
- seit: ...
- zuletzt beobachtet: ...

Fehlermeldung / Logs:
- ...

Ihr könnt mich für Rückfragen erreichen unter: ...

Danke für eure Unterstützung



Weitere Daten:
{data}
`,
			},
		},
		vertical_tabs: {
			unsaved: 'Ungespeicherte Änderungen',
		},
	},
	// Generische Texte des Import-Moduls. Alles, was zu einem konkreten Import gehört
	// (Feldnamen, Subjekte, eigene Fehlercodes), liegt in der App unter dem i18nPrefix des
	// Wizards und hat Vorrang vor den Schlüsseln hier.
	filters: {
		status: 'Status',
		role: 'Rolle',
		user: 'Verantw. Person',
	},
	modals: {
		me: {
			create_token: {
				title: 'Neuen Token erstellen',
				kind: 'Verwendung',
				endpoint: 'Endpunkt',
				kind_hint_pat: 'Für Automatisierungen und Skripte. Gilt für die REST-API, nicht für den MCP-Server.',
				kind_hint_mcp: 'Für KI-Assistenten wie Claude. Gilt nur für den MCP-Server, nicht für die REST-API.',
				expiry: 'Gültigkeit',
				expiry_1d: '1 Tag',
				expiry_1m: '1 Monat',
				expiry_3m: '3 Monate',
				expiry_1y: '1 Jahr',
				expiry_forever: 'Unbegrenzt',
				scope: 'Berechtigungen',
				scope_full: 'Alle eigenen',
				scope_limited: 'Ausgewählte',
				scope_hint: 'Entzogene Berechtigungen entfallen auch für den Token.',
				scope_global: 'Global',
				scope_count: '{count} ausgewählt',
				scope_none: 'Mindestens eine Berechtigung wählen.',
			},
			two_factor_setup: {
				title: 'Zwei-Faktor-Authentifizierung einrichten',
				text: 'Den QR-Code mit einer Authenticator-App scannen, zum Beispiel Microsoft Authenticator, Google Authenticator oder 1Password.',
				hint: 'Der Schlüssel wird nur dieses eine Mal angezeigt. Aktiv ist die Zwei-Faktor-Authentifizierung erst, wenn der erste Code bestätigt ist.',
				activate: 'Aktivieren',
			},
			two_factor_disable: {
				title: 'Zwei-Faktor-Authentifizierung deaktivieren',
				text: 'Danach genügt dein Passwort zum Anmelden. Zur Bestätigung bitte das aktuelle Passwort eingeben.',
			},
			show_token: {
				title: 'Token erstellt',
				text: 'Kopiere den Token jetzt – er wird aus Sicherheitsgründen nur dieses eine Mal angezeigt.',
				copy: 'In die Zwischenablage kopieren',
				copied: 'Token kopiert',
				mcp_url: 'Adresse des MCP-Servers',
				mcp_url_copied: 'Adresse kopiert',
			},
		},
		confirm: {
			remove_announcement: 'Ankündigung entfernen',
			remove_announcement_title: `Die Ankündigung "{title}" entfernen?`,
		},
		admin: {
			edit_user: {
				create: 'Neue Person einladen',
				edit: 'Person bearbeiten',
				sso_identities: 'Verknüpfte Anmeldekonten',
				sso_subject: 'Konto-ID',
				sso_last_login: 'Letzter Login',
				sso_groups: 'Gruppen',
				sso_unlink: 'Verknüpfung lösen',
				sso_unlink_confirm:
					'Die Verknüpfung mit dem {provider}-Konto lösen? Die nächste Anmeldung über {provider} verknüpft das Konto mit derselben E-Mail-Adresse erneut.',
			},
			set_user_password: {
				title: 'Passwort setzen',
				text: 'Die Person meldet sich ab jetzt mit diesem Passwort an. Teile es ihr auf einem sicheren Weg mit.',
				password: 'Neues Passwort',
				confirmation: 'Neues Passwort wiederholen',
				save: 'Passwort setzen',
			},
			remove_user: {
				title: 'Person entfernen',
				reasons: 'Gründe',
				mode: {
					delete: 'Die Person kann gelöscht werden.',
					anonymize_only: 'Die Person kann nur anonymisiert werden, weil noch Daten auf sie verweisen.',
					blocked: 'Die Person kann derzeit weder gelöscht noch anonymisiert werden.',
				},
				delete_info: 'Löschen entfernt die Person und alle ihre Daten endgültig.',
				anonymize_info:
					'Anonymisieren behält den Datensatz für Teams, Events und Abrechnungen, entfernt aber Name, E-Mail, Zugänge und alle persönlichen Daten. Die Person kann sich danach nicht mehr anmelden.',
				confirm: "Zur Bestätigung '{name}' eingeben",
				delete: 'Endgültig löschen',
				anonymize: 'Anonymisieren',
				deleted: 'Die Person wurde gelöscht.',
				anonymized: 'Die Person wurde anonymisiert.',
				failed: 'Die Aktion ist nicht erlaubt oder fehlgeschlagen. Die Gründe wurden aktualisiert.',
				load_failed: 'Es konnte nicht ermittelt werden, ob die Person entfernt werden kann.',
				confirm_label: 'Name zur Bestätigung',
			},
			edit_role: {
				create: 'Neue Rolle erstellen',
				edit: 'Rolle bearbeiten',
				permissions: 'Berechtigungen',
			},
			edit_webhook_incoming: {
				create: 'Neuen Webhook erstellen',
				edit: 'Webhook bearbeiten',
				auth_none: 'Keine',
				auth_basic: 'HTTP Basic',
				auth_token: 'Query Token',
				webhook_url: 'Webhook URL',
				headers: 'Headers',
				cleanup_enabled: 'Erfolgreiche Requests nach 7 Tagen automatisch löschen',
				remote_settings: 'Einstellungen für die sendende Applikation',
				no_handlers: 'In dieser Anwendung sind keine Webhook-Handler-Klassen verfügbar.',
			},
			edit_webhook_outgoing: {
				create: 'Neuen ausgehenden Webhook erstellen',
				edit: 'Ausgehenden Webhook bearbeiten',
				payload: 'Payload (Request-Body)',
				payload_hint: 'Bleibt das Feld leer, werden alle verfügbaren Daten des Ereignisses als JSON gesendet.',
				placeholders: 'Verfügbare Platzhalter',
				placeholders_hint: 'Klick auf einen Platzhalter fügt ihn in die Payload ein.',
				cleanup_enabled: 'Erfolgreiche Requests nach 7 Tagen automatisch löschen',
			},
			delete_role: {
				title: 'Rolle löschen',
				text: "Soll die Rolle '{item}' wirklich gelöscht werden?",
			},
			edit_context_role: {
				create: 'Neue Context Rolle erstellen',
				edit: 'Context Rolle bearbeiten',
				permissions: 'Berechtigungen',
			},
			delete_context_role: {
				title: 'Context Rolle löschen',
				text: "Soll die Context basierte Rolle '{item}' wirklich gelöscht werden?",
			},
		},
		image_upload: {
			resize_error: 'Das Bild konnte nicht verarbeitet werden.',
			select_image_file: 'Bitte wähle eine Bilddatei aus.',
		},
		delete_article_image: {
			title: 'Bild löschen',
			text: 'Möchtest du das Artikelbild wirklich löschen?',
		},
		show_location: {
			orders: 'Bestellungen',
			cart_items: 'Bestellpositionen',
		},
		table_column_filter: {
			title: 'Tabellen Spalten Filter',
			name: 'Name',
			show: 'Anzeigen',
		},
	},
	confirms: {
		delete_webhook_incoming: {
			title: 'Eingehenden Webhook löschen',
			text: 'Soll der Webhook "{item}" wirklich gelöscht werden? Dabei werden auch alle zugehörigen Webhook Requests gelöscht.',
		},
		delete_webhook_incoming_request: {
			title: 'Webhook Request löschen',
			text: 'Soll der Webhook Request wirklich gelöscht werden?',
		},
		delete_webhook_outgoing: {
			title: 'Ausgehenden Webhook löschen',
			text: 'Soll der ausgehende Webhook "{item}" wirklich gelöscht werden? Dabei werden auch alle zugehörigen Webhook Requests gelöscht.',
		},
		delete_webhook_outgoing_request: {
			title: 'Webhook Request löschen',
			text: 'Soll der Webhook Request wirklich gelöscht werden?',
		},
		replay_webhook_outgoing_request: {
			title: 'Webhook erneut senden',
			text: 'Soll der Request mit den gespeicherten Ereignisdaten erneut gesendet werden? Der Body wird mit dem aktuellen Payload-Template und der aktuellen URL des Webhooks neu erzeugt.',
		},
		revoke_token: {
			title: 'Token widerrufen',
			text: 'Soll der Token "{item}" wirklich widerrufen werden? Anwendungen, die diesen Token verwenden, verlieren sofort den Zugriff.',
		},
		delete_failed_job: {
			title: 'Fehlgeschlagenen Job löschen',
			text: 'Soll der fehlgeschlagene Job "{item}" wirklich gelöscht werden? Er kann danach nicht mehr erneut ausgeführt werden.',
		},
		delete_all_failed_jobs: {
			title: 'Alle fehlgeschlagenen Jobs löschen',
			text: 'Sollen wirklich alle {count} fehlgeschlagenen Jobs gelöscht werden? Sie können danach nicht mehr erneut ausgeführt werden.',
		},
		clear_mail_log: {
			title: 'Mail-Protokoll löschen',
			text: 'Sollen die Zähler für versendete und fehlgeschlagene Mails sowie die aufgezeichneten Fehler wirklich gelöscht werden? Die Prometheus-Metriken bleiben erhalten.',
		},
		wipe_metrics: {
			title: 'Metriken zurücksetzen',
			text: 'Sollen wirklich alle erfassten Metriken dieser Instanz zurückgesetzt werden? Die vom Prometheus-Server bereits abgeholten Daten bleiben erhalten.',
		},
		leave_unsaved: {
			title: 'Ungespeicherte Änderungen verwerfen?',
			text: 'Im Tab {tabs} gibt es ungespeicherte Änderungen. Verlässt du die Seite, gehen sie verloren. | In den Tabs {tabs} gibt es ungespeicherte Änderungen. Verlässt du die Seite, gehen sie verloren.',
		},
	},
	data: {
		letterhead_editor: {
			sender_name: 'Absender',
			addition_text: 'Zusatztext',
			return_line: 'Rücksendeangabe',
			claim: 'Claim',
			contact_lines: 'Kontaktblock',
			icon: 'Icon',
			text: 'Text',
			columns: 'Spalten',
			column_title: 'Überschrift',
			column_text: 'Zeilen',
			rows: 'Zeilen unter den Spalten',
			label: 'Bezeichnung',
			value: 'Wert',
			layout: 'Anordnung',
			logo_height: 'Logohöhe',
			logo_offset: 'Logoversatz',
			logo: 'Logo',
			addition: 'Zusatz',
			addition_height: 'Höhe Zusatz',
			addition_size: 'Schriftgröße Zusatz',
			addition_place: 'Lage Zusatz',
			addition_align: 'Ausrichtung zum Logo',
			footer_columns: 'Spalten',
			footer_rows: 'Zeilen darunter',
			footer_rule: 'Linie',
			claim_align: 'Claim',
			claim_by_addition: 'Claim unter dem Zusatz',
			contact: 'Kontaktblock',
			contact_bar: 'Balken am Kontaktblock',
			contact_icons: 'Icons im Kontaktblock',
			rule: 'Linie',
			align: 'Ausrichtung',
			address_top: 'Anschriftfeld ab oben',
			image_1_url: 'Bild 1',
			image_2_url: 'Bild 2',
			font_family: 'Schriftart',
			font_size: 'Schriftgröße',
			line_height: 'Zeilenabstand',
			ink_color: 'Überschriften',
			text_color: 'Text',
			muted_color: 'Gedämpft',
			accent_color: 'Akzent',
			rule_background: 'Linie',
			rule_height: 'Linienstärke',
			margin_left: 'Rand links',
			margin_right: 'Rand rechts',
			margin_inner: 'Rand innen',
			margin_outer: 'Rand außen',
			duplex: 'Doppelseitig',
			fold_marks: 'Faltmarken',
			punch_mark: 'Lochmarke',
			header_first_top: 'Kopf von oben, Seite 1',
			text_first_top: 'Text ab oben, Seite 1',
			header_follow_top: 'Kopf von oben, Folgeseiten',
			text_follow_top: 'Text ab oben, Folgeseiten',
			footer_first_bottom: 'Fuß von unten, Seite 1',
			footer_first_height: 'Fußhöhe, Seite 1',
			footer_follow_bottom: 'Fuß von unten, Folgeseiten',
			footer_follow_height: 'Fußhöhe, Folgeseiten',
			custom_css: 'CSS',
			closing: 'Grußformel',
		},
		block_editor: {
			design: 'Design',
			html: 'Eigenes HTML',
			css: 'Eigenes CSS',
			settings: 'Werte (JSON)',
			image_height: 'Höhe',
			image_width: 'Breite',
			bleed: 'Bis an den Rand',
		},
		mail_theme: {
			content_width: 'Inhaltsbreite',
			embed_images: 'Bilder in die Mail einbetten',
			copyright: 'Copyright',
			font_family: 'Schriftart',
			page_background: 'Seitenhintergrund',
			card_background: 'Inhaltshintergrund',
			card_border_color: 'Rahmenfarbe',
			text_color: 'Textfarbe',
			link_color: 'Linkfarbe',
			primary_color: 'Primärfarbe',
			success_color: 'Erfolgsfarbe',
			error_color: 'Fehlerfarbe',
			header_rule: 'Linie unter dem Kopf',
			footer_rule: 'Linie über dem Fuß',
			ink_color: 'Schriftfarbe der Überschriften',
			muted_color: 'Gedämpfte Farbe',
			accent_color: 'Akzentfarbe',
			rule: 'Linie',
			rule_height: 'Linienstärke',
			rule_color: 'Die Farbe der Linie ohne Verlauf',
			rule_px: 'Die Stärke der Linie in Pixeln',
			header_color: 'Kopfbereichsfarbe',
			sender_name: 'Name des Absenders',
			image_1_url: 'Bild 1, als Bildquelle',
			image_2_url: 'Bild 2, als Bildquelle',
			claim: 'Der Claim',
			addition_text: 'Der Zusatz zum Logo',
			has_footer_columns: 'Ob die Fußzeile Spalten hat',
			footer_columns: 'Die Spalten der Fußzeile',
			footer_rows: 'Die Zeilen unter den Spalten',
			items: 'Die Angaben einer Zeile',
			title: 'Die Überschrift der Spalte',
			text: 'Der Text der Spalte',
			label: 'Die Bezeichnung',
			value: 'Der Wert',
			app_url: 'Die Adresse der App',
			logo_width: 'Logo-Breite',
			footer_text: 'Fußzeilentext',
			footer_color: 'Fußzeilenfarbe',
			custom_css: 'Zusätzliches CSS',
			closing: 'Grußformel',
		},
		personal_access_token: {
			id: 'Id',
			name: 'Name',
			kind: 'Verwendung',
			kind_pat: 'REST-API',
			kind_mcp: 'MCP',
			abilities: 'Berechtigungen',
			abilities_full: 'Alle',
			abilities_lost: 'entzogen',
			expires_at: 'Läuft ab',
			last_used_at: 'Zuletzt benutzt',
			created_at: 'Erstellt',
		},
		user: {
			id: 'Id',
			firstname: 'Vorname',
			lastname: 'Nachname',
			avatar: 'Avatar',
			labels: 'Label',
			email: 'E-Mail-Adresse',
			role: 'Rolle',
			roles: 'Rollen',
			context_role: 'Rolle',
			context_roles: 'Rollen',
			createdAt: 'Erstellt am',
			last_user_login: 'Letzter Login',
		},
		role: {
			id: 'Id',
			name: 'Name',
			guard_name: 'Guard',
			description: 'Beschreibung',
			permissions: 'Berechtigungen',
		},
		permission: {
			id: 'Id',
			name: 'Name',
			guard_name: 'Guard',
			description: 'Beschreibung',
			requires_two_factor: '2FA benötigt',
		},
		config: {
			card: 'Einstellungen',
			key: 'Schlüssel',
			public: 'Öffentlich',
			type: 'Typ',
			default: 'Standard',
			value: 'Wert',
			setting: 'Einstellung',
			keys: {
				app: {
					name: {
						label: 'Name der Anwendung',
						help: 'Steht im Kopf und in der Seitenleiste.',
					},
					short_name: {
						label: 'Kurzname',
						help: 'Ersetzt den Namen im Kopf auf schmalen Bildschirmen.',
					},
					primary_color: {
						label: 'Hauptfarbe',
						help: 'Buttons, Links und aktive Elemente. Die Schrift darauf wird weiß oder dunkel, je nachdem, was besser lesbar ist.',
					},
					secondary_color: {
						label: 'Zweitfarbe',
						help: 'Nebenschaltflächen und zurückhaltende Elemente.',
					},
					operator_name: {
						label: 'Betreiber',
						help: 'Steht in der Fußzeile der Anmeldeseite, neben den Links zu Impressum und Datenschutz.',
					},
					operator_url: {
						label: 'Website des Betreibers',
						help: 'Der Betreibername verlinkt hierhin. Leer verlinkt er auf etherforce.net.',
					},
					show_applications: {
						label: 'Weitere Anwendungen zeigen',
						help: 'Zeigt im Kopf den Umschalter zu den anderen Anwendungen.',
					},
				},
				auth: {
					invitation_expire_days: {
						label: 'Gültigkeit der Einladung',
						help: 'So lange bleibt der Link gültig, mit dem ein neues Konto sein Passwort setzt.',
						unit: 'Tage',
					},
				},
			},
		},
		webhook_incoming: {
			id: 'Id',
			name: 'Name',
			class: 'Klasse',
			endpoint: 'API-Endpunkt',
			auth_type: 'Authentifizierung',
			client_id: 'Benutzername',
			client_secret: 'Passwort',
			token: 'Token',
			requests_count: '# Requests',
		},
		webhook_incoming_request: {
			service_id: 'Service',
			action: 'Action',
			ip_address: 'IP',
			dns: 'DNS',
			method: 'Methode',
			created_at: 'Zeitpunkt',
			payload: 'Payload',
			data: 'Daten',
			success: 'Status',
		},
		webhook_outgoing: {
			id: 'Id',
			name: 'Name',
			event_class: 'Ereignis',
			url: 'URL',
			method: 'Methode',
			enabled: 'Aktiv',
			requests_count: '# Requests',
			last_triggered_at: 'Zuletzt ausgelöst',
		},
		webhook_outgoing_request: {
			id: 'Id',
			created_at: 'Zeitpunkt',
			event_class: 'Ereignis',
			url: 'URL',
			method: 'Methode',
			attempt: 'Versuch',
			status_code: 'Statuscode',
			state: 'Ergebnis',
		},
	},
	tabs: {
		admin_settings: {
			legal_pages: 'Rechtliche Seiten',
			mail_theme: 'Mail-Design',
			design: 'Absender & Gestaltung',
			roles_and_permissions: 'Rollen & Berechtigungen',
			webhook_incomings: 'Eingehende Webhooks',
			webhook_outgoings: 'Ausgehende Webhooks',
			settings: 'Einstellungen',
			groups: {
				access: 'Zugriff',
				appearance: 'Erscheinungsbild',
				communication: 'Kommunikation',
				integrations: 'Integrationen',
				system: 'System',
			},
			letterhead: 'Briefpapier',
		},
		development: {
			tools: 'Tools',
			stores: 'Stores',
			authentication: 'Authentifizierung',
			select: 'Select Components',
			php_info: 'PHP Info',
			images: 'Bilder',
			media_store: 'S3 Speicher',
			influx_store: 'InfluxDB',
			db_store: 'Datenbank',
			redis_store: 'Redis',
			queue_store: 'Queue',
			mail_store: 'E-Mail',
			pdf_renderer: 'PDF-Renderer',
			metrics_store: 'Metriken',
		},
		me: {
			general: 'Allgemein',
			notifications: 'Benachrichtigungen',
			security: 'Sicherheit',
		},
		context_settings: {
			groups: {
				general: 'Allgemein',
				members: 'Mitglieder',
				appearance: 'Erscheinungsbild',
				communication: 'Kommunikation',
				integrations: 'Integrationen',
			},
			design: 'Mail- & Briefpapier-Design',
		},
	},
	popovers: {
		event: {
			preferred_crs: {
				title: 'Bevorzugtes Koordinatensystem',
				text: 'Koordinatensystem welches als Standard bei dem Event ausgewählt wird.',
			},
		},
	},
	enums: {
		boolean: {
			true: 'Ja',
			false: 'Nein',
		},
		transformation_input_methode: {
			manual: 'Direkte Eingabe',
			reference: 'Referenzpunkte',
		},
		month_names: {
			undefined: '',
			0: 'Januar',
			1: 'Februar',
			2: 'März',
			3: 'April',
			4: 'Mai',
			5: 'Juni',
			6: 'Juli',
			7: 'August',
			8: 'September',
			9: 'Oktober',
			10: 'November',
			11: 'Dezember',
		},
		day_names: {
			0: 'Sonntag',
			1: 'Montag',
			2: 'Dienstag',
			3: 'Mittwoch',
			4: 'Donnerstag',
			5: 'Freitag',
			6: 'Samstag',
		},
		day_short_names: {
			0: 'So',
			1: 'Mo',
			2: 'Di',
			3: 'Mi',
			4: 'Do',
			5: 'Fr',
			6: 'Sa',
		},
	},
	user_removal: {
		reasons: {
			self: 'Das eigene Konto kann nicht entfernt werden.',
			last_remover: 'Die Person ist die letzte, die Personen entfernen darf.',
			referenced: '{count} Einträge in {table}.{column} verweisen auf die Person.',
		},
	},
};
